import React from 'react';

export const ResourceBar = ({ label, current, max, color, theme, compact = false }) => {
  const pct = Math.max(0, Math.min(100, (current / max) * 100));
  const t = theme.typography || {};
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: compact ? '0.7rem' : '0.78rem' }}>
      <span style={{
        color: theme.colors.textMuted,
        fontWeight: 700,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        fontSize: '0.65rem',
        minWidth: 18,
        fontFamily: t.fontFamily,
      }}>{label}</span>
      <div style={{
        flex: 1,
        height: compact ? 6 : 10,
        background: 'rgba(0,0,0,0.5)',
        borderRadius: 999,
        overflow: 'hidden',
        border: `1px solid ${theme.colors.borderLight}`,
      }}>
        <div style={{
          width: `${pct}%`, height: '100%',
          background: `linear-gradient(90deg, ${color}cc, ${color})`,
          boxShadow: `0 0 8px ${color}66, inset 0 1px 0 rgba(255,255,255,0.15)`,
          borderRadius: 999,
          transition: 'width 0.4s cubic-bezier(.2,.8,.2,1)',
        }} />
      </div>
      <span style={{
        color,
        fontFamily: t.monoFamily || 'ui-monospace, monospace',
        fontWeight: 700,
        fontSize: '0.74rem',
        minWidth: 44,
        textAlign: 'right',
        textShadow: `0 0 8px ${color}66`,
      }}>{current}/{max}</span>
    </div>
  );
};
